import { render, staticRenderFns } from "./listagemProcessosCredenciar.vue?vue&type=template&id=aaa28180&scoped=true&lang=pug&"
import script from "./listagemProcessosCredenciar.vue?vue&type=script&lang=js&"
export * from "./listagemProcessosCredenciar.vue?vue&type=script&lang=js&"
import style0 from "./listagemProcessosCredenciar.vue?vue&type=style&index=0&id=aaa28180&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa28180",
  null
  
)

export default component.exports